module.exports = __webpack_public_path__ + "files/8d4a23e30c0e8541e36dba3a95b199c2.svg";